var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-event"},[(_vm.loading)?_c('loading-wheel'):_c('div',{staticClass:"flexcontainer"},[_c('SpeakerList',{attrs:{"breukel":_vm.event.api.breukel,"meetings":_vm.JsonEventSlots,"fullscreenMode":true,"viewOnly":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }